import { 
  collection, 
  addDoc, 
  updateDoc, 
  deleteDoc, 
  doc, 
  getDocs, 
  getDoc,
  query,
  where,
  Timestamp 
} from 'firebase/firestore';
import { db } from '../config/firebase.config';
import { Customer } from '../types';

class CustomerService {
  private collectionName = 'customers';

  async create(customerData: Omit<Customer, 'id' | 'createdAt' | 'updatedAt'>): Promise<string> {
    const docRef = await addDoc(collection(db, this.collectionName), {
      ...customerData,
      createdAt: Timestamp.now(),
      updatedAt: Timestamp.now()
    });
    return docRef.id;
  }

  async getAll(): Promise<Customer[]> {
    const snapshot = await getDocs(collection(db, this.collectionName));
    const customers = snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    } as Customer));
    // 클라이언트 측 정렬
    return customers.sort((a, b) => a.name.localeCompare(b.name));
  }

  async getById(id: string): Promise<Customer | null> {
    const docRef = doc(db, this.collectionName, id);
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      return { id: docSnap.id, ...docSnap.data() } as Customer;
    }
    return null;
  }

  async getByType(type: 'client' | 'partner'): Promise<Customer[]> {
    const q = query(
      collection(db, this.collectionName),
      where('type', '==', type)
    );
    const snapshot = await getDocs(q);
    const customers = snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    } as Customer));
    // 클라이언트 측 정렬
    return customers.sort((a, b) => a.name.localeCompare(b.name));
  }

  async update(id: string, customerData: Partial<Customer>): Promise<void> {
    const docRef = doc(db, this.collectionName, id);
    await updateDoc(docRef, {
      ...customerData,
      updatedAt: Timestamp.now()
    });
  }

  async delete(id: string): Promise<void> {
    const docRef = doc(db, this.collectionName, id);
    await deleteDoc(docRef);
  }
}

export const customerService = new CustomerService();
